import barba from "@barba/core";
import Address from "../common/address";

const HtmlUtil = {};

HtmlUtil.getEjsElement = (ejsTemplate,data) => {
    ejs.delimiter = '$';
    // let element = document.createElement('template');
    // element.insertAdjacentHTML = ejs.render(ejsTemplate, data);
    // return element.content.firstChild;

    let str = ejs.render(ejsTemplate, data);
    return HtmlUtil.getStrElement(str);
    // let template = document.createElement('template');
    // if ( 'content' in template ) {
    //     template.innerHTML = str;
    //     return template.content.firstChild;
    // }
    //
    // template = document.createElement( str.substr( 0, 4 ) === '<li ' ? 'ul' : 'div' );
    // template.innerHTML = str;
    // return template.firstChild;
}

HtmlUtil.getStrElement = (str) => {
    let template = document.createElement('template');
    if ( 'content' in template ) {
        template.innerHTML = str;
        return template.content.firstChild;
    }

    template = document.createElement( str.substr( 0, 4 ) === '<li ' ? 'ul' : 'div' );
    template.innerHTML = str;
    return template.firstChild;
}

HtmlUtil.getUrlParams = ()=> {
    var params = {};

    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,
        function(str, key, value) {
            params[key] = value;
        }
    );

    return params;
}

HtmlUtil.goLink = (link) => {
    if (new Address().isBarba) {
        barba.go(link);
    } else {
        window.location = link;
    }

}

HtmlUtil.getPos = (el)=> {
    for (var lx=0, ly=0;  el != null;  lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent);
    return {x: lx,y: ly};
}

HtmlUtil.getEjsStrElement = (ejsTemplate,data) => {

    ejs.delimiter = '$';

    let str = ejs.render(ejsTemplate, data);
    return str;
}

export { HtmlUtil };
